export enum MailAccountSearchOrder {
  OrderByMailAccountId = 1,
  OrderByName = 2,
  OrderByLicense = 3,
  OrderByCodeSia = 4,
  OrderByAnagId = 5,
  OrderByEmail = 6,
  OrderByProvider = 7,
  OrderByState = 8,
  OrderByArchive = 9,
  OrderBySpaceUsed = 10,
  OrderByConfigurationCompleted = 11,
  OrderByConnectionStatus = 12,
}
